import styled from 'styled-components';

import { Form } from '@dreryk/react-components';

export const StyledForm = styled(Form)`
   display: grid;
   grid-template-columns: 151px 1fr;
   gap: 20px;
   width: 100%;
`;

StyledForm.displayName = 'StyledForm';

export const OneColumnSpan = styled.div`
   grid-column: span 2;
   display: flex;
   flex-direction: column;
   gap: 20px;
`;

OneColumnSpan.displayName = 'OneColumnSpan';
